<template>
    <div>
        <img v-if="this.$i18n.locale == 'ar'" class="imgs" src="../../assets/stopTaking/WT_AR.png" alt="">
        <img v-else class="imgs" src="../../assets/stopTaking/WT_EN.png" alt="">
        <div class="popBox" v-if="this.$route.query.type">
            <template v-if="this.$route.query.type == 1">
                <img v-if="this.$i18n.locale == 'ar'" class="imgs arPopImg" src="../../assets/stopTaking/1ar.png" alt="">
                <img v-else class="imgs" src="../../assets/stopTaking/1en.png" alt="">
            </template>
            <template v-if="this.$route.query.type == 2">
                <img v-if="this.$i18n.locale == 'ar'" class="imgs arPopImg" src="../../assets/stopTaking/2ar.png" alt="">
                <img v-else class="imgs" src="../../assets/stopTaking/2en.png" alt="">
            </template>
            <template v-if="this.$route.query.type == 3">
                <img v-if="this.$i18n.locale == 'ar'" class="imgs arPopImg" src="../../assets/stopTaking/3ar.png" alt="">
                <img v-else class="imgs" src="../../assets/stopTaking/3en.png" alt="">
            </template>
            <template v-if="this.$route.query.type == 4">
                <img v-if="this.$i18n.locale == 'ar'" class="imgs arPopImg" src="../../assets/stopTaking/4ar.png" alt="">
                <img v-else class="imgs" src="../../assets/stopTaking/4en.png" alt="">
            </template>
            <template v-if="this.$route.query.type == 5">
                <img v-if="this.$i18n.locale == 'ar'" class="imgs arPopImg" src="../../assets/stopTaking/5ar.png" alt="">
                <img v-else class="imgs" src="../../assets/stopTaking/5en.png" alt="">
            </template>
            <template v-if="this.$route.query.type == 6">
                <img v-if="this.$i18n.locale == 'ar'" class="imgs arPopImg" src="../../assets/stopTaking/6ar.png" alt="">
                <img v-else class="imgs" src="../../assets/stopTaking/6en.png" alt="">
            </template>
        </div>
    </div>
</template>
<script>
export default {
    name: "App",
    components: {},
    data() {
        return {
            userInfo: [], 
        };
    },
    created() {
        document.title = 'Welcome'
        this.$completes.complete("getUserInfo");
        window.getUserInfo = this.getUserInfo
        window['getUserInfo'] = (data) => {
            this.getUserInfo(data);
        }
    },
    mounted() {
    },
    methods: {
        getUserInfo(data) {
            this.userInfo = JSON.parse(data);
            let langs = this.userInfo.lang.substring(0, 2)
            let lang = this.userInfo.lang
            if (langs == 'zh') {
                if (lang == 'zh_TW' || lang == 'zh_HK') {
                    this.$i18n.locale = 'tc'
                }
                else {
                    this.$i18n.locale = 'zh'
                }
            }
            else if (langs == 'en') {
                this.$i18n.locale = 'en'
            }
            else if (langs == 'ar') {
                this.$i18n.locale = 'ar'
            }
            else {
                this.$i18n.locale = 'en'
            }
            
            document.querySelector('html').setAttribute('lang', this.$i18n.locale);
        },
    },
};
</script>
<style>
* {
    margin: 0;
    padding: 0;
}
.popBox{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
}
.popBox img{
    width: 5.8rem;
    position: absolute;
    top: 1.4rem;
    left: 48%;
    transform: translateX(-50%);
    height: auto;
}
.popBox .arPopImg{
    left: 50%;
}
</style>